<template>
  <div>
    <label v-for="(label, index) in options" :key="index">
      <input type="radio" :value="index" v-model="selectedValue" @change="handleChange">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'CustomRadio',
  props: {
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedValue: this.modelValue
    };
  },
  methods: {
    handleChange(event) {
      this.selectedValue = event.target.value;
      this.$emit('update:modelValue', this.selectedValue);
    }
  }
};
</script>
